
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.498.5a.116.116 0 00-.087.039c-.174.188-.483 1.867-.637 2.581L6.18 5.147c-.145.135-.878.821-1.028.966a.735.735 0 00-.241.308.097.097 0 000 .034v.449a.12.12 0 00.121.121h.033l.744-.213-.16.739-2.775 2.842-.033-.415a.122.122 0 00-.054-.087l-.139-.096a.12.12 0 00-.189.096v2.466a.12.12 0 00.121.121h.096a.122.122 0 00.107-.063l.13-.256 3.06.227v.521c-.001.053.032.1.082.116l.308.102v.265c0 .067.055.121.121.121h.685l.082.878a.122.122 0 00.121.111h.256a.122.122 0 00.121-.111l.082-.878h.685a.121.121 0 00.121-.121v-.265l.308-.102a.119.119 0 00.082-.116v-.521l3.06-.227.13.256a.122.122 0 00.107.063h.096a.12.12 0 00.121-.121V9.862a.12.12 0 00-.189-.096l-.139.096a.122.122 0 00-.054.087l-.033.415-2.775-2.842-.16-.739.744.213h.033a.12.12 0 00.121-.121v-.449a.097.097 0 000-.034.735.735 0 00-.241-.308c-.15-.126-.883-.811-1.028-.966l-.613-2.012c-.13-.7-.483-2.379-.632-2.567A.118.118 0 007.488.5h.01z"}})])
          )
        }
      }
    